import React from "react";
import PropTypes from "prop-types";

function RadioButton(props) {
  const { item } = props;
  return (
    <input
      type="radio"
      disabled={props.isDisabled}
      title={item.ToolTip?.Content || ""}
      style={{
        borderColor: "black",
        backgroundColor: "white",
        width: item.Width,
        height: item.Height,
        position: "absolute",
        top: item.SetTop,
        left: item.SetLeft + 10,
      }}
    />
  );
}

RadioButton.propTypes = {
  item: PropTypes.shape({
    ToolTip: PropTypes.shape({
      Content: PropTypes.string,
    }),
    Width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    Height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    SetTop: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    SetLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  isDisabled: PropTypes.bool,
};

RadioButton.defaultProps = {
  isDisabled: false,
};

export default RadioButton;
